var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafelock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 15.8333V9.16667C3.33337 8.24619 4.07957 7.5 5.00004 7.5H15C15.9205 7.5 16.6667 8.24619 16.6667 9.16667V15.8333C16.6667 16.7538 15.9205 17.5 15 17.5H5.00004C4.07957 17.5 3.33337 16.7538 3.33337 15.8333Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11.6667,
    r: 1.66667,
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 6.66667V5.83333C6.66663 3.99238 8.15901 2.5 9.99996 2.5V2.5C11.8409 2.5 13.3333 3.99239 13.3333 5.83333V6.66667",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 18.3333V17.5C6.66663 15.6591 8.15901 14.1667 9.99996 14.1667V14.1667C11.8409 14.1667 13.3333 15.6591 13.3333 17.5V18.3333",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafelock);
export default __webpack_public_path__ + "static/media/Safelock.d2deadbee822358b3fd5dc2108a1f738.svg";
export { ForwardRef as ReactComponent };